import { cn } from '../../lib/cn';
import type { PerformanceRow } from '../../enterprisequality/framework';

type Props = { benchmarks?: PerformanceRow[] };

export function PerformanceEngineeringPanel({ benchmarks = [] }: Props) {
  return (
    <div className="grid gap-2 sm:grid-cols-2">
      {benchmarks.map((b) => (
        <div key={b.metric} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <p className="text-sm font-medium">{b.metric}</p>
          <p className="mt-1 text-lg font-semibold">{b.value}</p>
          <div className="mt-1 flex items-center justify-between">
            <p className="text-xs text-slate-500">target {b.target}</p>
            <span className={cn(
              'text-xs font-medium',
              b.status === 'passed' ? 'text-success-600' : 'text-error-600',
            )}>
              {b.status}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}
